import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHookSection } from './components/OpeningHookSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttemptsSection } from './components/FailedAttemptsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { SectionDivider } from './components/SectionDivider';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen bg-cream selection:bg-gold/30 selection:text-burgundy-deep" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SectionDivider data-id="element-3" />
      <OpeningHookSection data-id="element-4" />
      <SectionDivider data-id="element-5" />
      <ProblemSection data-id="element-6" />
      <SectionDivider data-id="element-7" />
      <FailedAttemptsSection data-id="element-8" />
      <SectionDivider data-id="element-9" />
      <MechanismSection data-id="element-10" />
      <SectionDivider data-id="element-11" />
      <WhatYouGetSection data-id="element-12" />
      <SectionDivider data-id="element-13" />
      <WhoIsForSection data-id="element-14" />
      <SectionDivider data-id="element-15" />
      <HowItWorksSection data-id="element-16" />
      <SectionDivider data-id="element-17" />
      <ProofSection data-id="element-18" />
      <SectionDivider data-id="element-19" />
      <FAQSection data-id="element-20" />
      <SectionDivider data-id="element-21" />
      <OfferSection data-id="element-22" />
      <Footer data-id="element-23" />
    </main>;
}